import { styled } from '@mui/material/styles';
import { sizes } from 'src/themes/sizes';

export const Background = styled('div')(({ theme }) => ({
  backgroundColor: theme.palette.green.tint,
  width: '100%',
  height: '100vh',
  minHeight: sizes.box.minHeight.tall,
  overflowX: 'hidden',
  display: 'flex',
  justifyContent: 'center',
  [theme.breakpoints.down('sm')]: {
    minHeight: '100vh',
  },
}));

export const MessageBox = styled('div')(({ theme }) => ({
  position: 'relative',
  marginTop: theme.spacing(18),
  backgroundColor: '#FFFFFF',
  width: '100%',
  maxWidth: sizes.box.maxWidth,
  height: sizes.box.minHeight.short,
  boxShadow: '0px 20px 25px -5px rgba(0, 0, 0, 0.1), 0px 10px 10px -5px rgba(0, 0, 0, 0.04)',
  borderRadius: sizes.radius.md,
  padding: `${theme.spacing(7.5)} ${theme.spacing(10)} ${theme.spacing(5)}`,
  boxSizing: 'border-box',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  [theme.breakpoints.down('sm')]: {
    margin: 0,
    height: '100vh',
    maxWidth: '100vw',
    borderRadius: 0,
    padding: `${theme.spacing(12.5)} ${theme.spacing(3.5)} ${theme.spacing(3.75)}`,
  },
  [theme.breakpoints.down('xs')]: {
    padding: `${theme.spacing(7.5)} ${theme.spacing(2.5)} ${theme.spacing(2.5)}`,
  },
}));

export const Title = styled('h1')(({ theme }) => ({
  fontSize: sizes.fontSize.h1Large,
  fontWeight: 700,
  margin: 0,
  color: theme.palette.green.dark,
}));

export const ErrorCategory = styled('div')(({ theme }) => ({
  fontWeight: 900,
  marginTop: theme.spacing(2.5),
  fontSize: sizes.fontSize.titleSmall,
  color: theme.palette.green.primary,
}));

export const Description = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  fontSize: sizes.fontSize.body,
  color: theme.palette.text.light,
}));
